import { render, staticRenderFns } from "./SearchResultTrade.vue?vue&type=template&id=b95fe420&"
import script from "./SearchResultTrade.vue?vue&type=script&lang=js&"
export * from "./SearchResultTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports